/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type JobRunStatus =
  | 'canceled'
  | 'failed'
  | 'in_progress'
  | 'init'
  | 'succeeded';

export type JobRunUpdateInput = {
  completionNotifyImportId?: string | null | undefined;
  completionNotifyOrigin?: string | null | undefined;
  completionNotifyProductName?: string | null | undefined;
  completionNotifyStatus?: string | null | undefined;
  jobName: string;
  jobRunId: string;
  s3LogPath?: string | null | undefined;
  status?: JobRunStatus | null | undefined;
  tenantId: string;
};

export type CancelDbpjKitWorkerJobRunMutationVariables = Exact<{
  input: Types.JobRunUpdateInput;
}>;


export type CancelDbpjKitWorkerJobRunMutation = { cnutUpdateJobRun:
    | { __typename: 'JobRunUpdateOutput', jobRunId: string }
    | { __typename: 'ValidationError', fields: Array<{ __typename: 'ValidationErrorField', code: string | null, message: string, path: string }> }
   };


export const CancelDbpjKitWorkerJobRunDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelDBPJKitWorkerJobRun"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JobRunUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutUpdateJobRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobRunUpdateOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobRunId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CancelDbpjKitWorkerJobRunMutation, CancelDbpjKitWorkerJobRunMutationVariables>;